import { UserManager } from "oidc-client";
import { TokenService } from "./token.service";
import { IWindowService, IQService, IRequestConfig, IPromise } from "angular";


export class AuthInterceptor {

    static factory() {
        const factoryFn = ($q, $window, $injector, userManager, webUserManager, boardWebEndpoint) => new AuthInterceptor($q, $window, $injector, userManager, webUserManager, boardWebEndpoint);
        factoryFn.$inject = ["$q", "$window", "$injector", "BoardWebAdminUserManager", "BoardWebUserManager", "WEB_ENDPOINT"];
        return factoryFn;
    }

    static $inject = ["$q", "$window", "$injector", "BoardWebAdminUserManager", "BoardWebUserManager", "WEB_ENDPOINT"];
    constructor(private $q: IQService, private $window: IWindowService, private $injector: ng.auto.IInjectorService, private userManager: UserManager, private webUserManager: UserManager, private boardWebEndpoint) {
        this.request = (config: IRequestConfig): IRequestConfig => {

            const isAdminEndpoint = config.url.indexOf("api") === 0;
            const isWebEndpoint = config.url.indexOf(boardWebEndpoint) !== -1;

            if (!isAdminEndpoint && !isWebEndpoint) {
                return config;
            }

            config.headers = config.headers || {};

            const tokenService = $injector.get<TokenService>("tokenService");

            config.headers["Authorization"] = `Bearer ${isWebEndpoint ? tokenService.boardWebAccessToken : tokenService.boardWebAdminAccessToken}`;

            return config;
        };

        this.responseError = (rejection): IPromise<any> => {
            // redirect to login page if unauthorized
            // console.log("AuthResponseError: ", rejection);
            if (rejection.status === 401) {
                let deferred = $q.defer();

                this.userManager.signinSilent().then(deferred.resolve, deferred.reject);

                return deferred.promise.then(() => {
                    return $injector.get("$http")(rejection.config);
                });
            }

            if (rejection.status === 420 || rejection.status === 419) {
                let deferred = $q.defer();
                this.webUserManager.removeUser();
                this.webUserManager.signinPopup().then(deferred.resolve, deferred.reject);
                return deferred.promise.then(() => {
                    return $injector.get("$http")(rejection.config);
                });

            }

            return $q.reject(rejection);
        };
    }

    request: (config: IRequestConfig) => IRequestConfig;
    responseError: (rejection) => IPromise<any>;
}


// WEBPACK FOOTER //
// ./app/core/core.authInterceptor.ts